import type { ComponentEditorMetaDataDefinition } from '../types';

const metaData: ComponentEditorMetaDataDefinition = {
  duplicatable: false,
  skipInQuickEditPanel: true,
};

export default metaData;
